import EventBus from './event-bus'

interface SignalEventMap {
  trigger: () => void
}

export default class Signal {
  private eventBus = new EventBus<SignalEventMap>()

  subscribe = (callback: () => void) => {
    this.eventBus.on('trigger', callback)
  }

  unsubscribe = (callback: () => void) => {
    this.eventBus.off('trigger', callback)
  }

  trigger = () => {
    this.eventBus.emit('trigger')
  }
}
